import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container', 'sentinel']
  static values = { url: String }

  initialize() {
    this._observer = new IntersectionObserver(this._onIntersect.bind(this), {
      rootMargin: '200px',
    })
  }

  connect() {
    if (this.hasSentinelTarget) {
      this._observer.observe(this.sentinelTarget)
    }
  }

  disconnect() {
    this._observer.disconnect()
  }

  sentinelTargetConnected(el) {
    this._observer.observe(el)
  }

  sentinelTargetDisconnected(el) {
    this._observer.unobserve(el)
  }

  async _onIntersect(entries) {
    const entry = entries[0]
    if (!entry.isIntersecting) return

    const sentinel = this.sentinelTarget
    const cursor = sentinel.dataset.cursor
    if (!cursor) return

    // Stop observing while fetching to avoid double-fires
    this._observer.unobserve(sentinel)

    try {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set('cursor', cursor)

      const response = await fetch(url.toString(), {
        headers: { Accept: 'application/json' },
      })

      if (!response.ok) return

      const { items_html, next_cursor } = await response.json()

      this.containerTarget.insertAdjacentHTML('beforeend', items_html)

      if (next_cursor) {
        sentinel.dataset.cursor = next_cursor
        this._observer.observe(sentinel)
      }
      else {
        sentinel.remove()
      }
    }
    catch {
      // Network error — re-observe so the user can scroll again to retry
      this._observer.observe(sentinel)
    }
  }
}
